import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';

import sanitizeHtml from 'sanitize-html';

import styles from './consent.module.scss';
import { IConsentProps } from './types';

import { Loader } from 'src/components/ui';
import { getPrivacy, sanitizeOptions } from '~utils';

export const Consent: FC<IConsentProps> = ({ className = '', ...rest }) => {
  const [consentText, setConsentText] = useState('');

  useEffect(() => {
    getPrivacy('consent').then(data => {
      setConsentText(data);
    });
  }, []);

  return (
    <div className={clsx(styles.container, className)} {...rest}>
      {consentText ? (
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(consentText, sanitizeOptions) }}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};
